import { Badge, Group } from "@mantine/core";

import type { Blend } from "../puzzle";

export interface BlendDisplayProps {
  readonly blend: Blend;
  /// Accessible name for the blend list. Defaults to the daily wording;
  /// the random-blend route overrides it.
  readonly label?: string;
}

export function BlendDisplay({ blend, label = "today's blend" }: BlendDisplayProps) {
  return (
    <Group gap="xs" role="list" aria-label={label}>
      {blend.map((word, i) => (
        <Badge key={`${i}-${word}`} size="lg" variant="light" role="listitem">
          {word}
        </Badge>
      ))}
    </Group>
  );
}
